import React from 'react';
import PropTypes from 'prop-types';
import Container from 'reactstrap/lib/Container';
import './awards-accolades.scss';

export function AwardsAccolades({
  title = '',
  content = '',
  mailTo = '',
  email = '',
  anchorClassName = 'text-primary',
}) {
  return (
    <Container className="top-rated-awards-accolades text-center cool-gray-100">
      <small className="d-block mx-auto size-12">
        <header className="fw-bold">{title}</header>
        {content}{' '}
        <a href={mailTo} className={anchorClassName}>
          {email}
        </a>
        .
      </small>
    </Container>
  );
}

AwardsAccolades.propTypes = {
  title: PropTypes.string,
  content: PropTypes.string,
  mailTo: PropTypes.string,
  email: PropTypes.string,
  anchorClassName: PropTypes.string,
};
